const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export class ApiError extends Error {
  constructor(
    public status: number,
    public body: unknown,
  ) {
    super(`API ${status}`);
  }
}

const request = async (
  method: string,
  path: string,
  body: unknown,
  token: string | null,
  actAs: string | null,
): Promise<Response> => {
  const headers: Record<string, string> = { Accept: 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (actAs) headers['X-Act-As'] = actAs;

  return fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
};

export const apiGet = async <T>(
  path: string,
  token: string | null,
  actAs: string | null = null,
): Promise<T> => {
  const res = await request('GET', path, undefined, token, actAs);
  if (!res.ok) {
    throw new ApiError(res.status, await res.json().catch(() => ({})));
  }
  return res.json() as Promise<T>;
};

export const apiSend = async <T>(
  method: 'POST' | 'PUT' | 'DELETE' | 'PATCH',
  path: string,
  body: unknown,
  token: string | null,
  actAs: string | null = null,
): Promise<T> => {
  const res = await request(method, path, body, token, actAs);
  if (!res.ok) {
    throw new ApiError(res.status, await res.json().catch(() => ({})));
  }
  // Some endpoints (DELETE) may return empty body; tolerate that.
  const text = await res.text();
  return (text ? JSON.parse(text) : null) as T;
};
